import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopSection from "../../LT/TopSection";
import AlertCards from "./AlertCards";
import { Loader } from "../../../components/common/Loader";
import SupplierAlertCard from "./SupplierAlertCard";
import { getAlertSupplierConfirmationSlice } from "../../../redux/actions/getAlertSupplierConfirmationSlice";
import { getAlertSupplierConfirmationEndpoint, getAlertSupplierUnconfirmedConsolidatedEndpoint, getBuyerForecastHistoryNotificationsEndpoint } from "../../../common/endpoints";
import { getAlertSupplierUnconfirmedConsolidatedSlice } from "../../../redux/actions/getAlertSupplierUnconfirmedConsolidatedSlice";
import { getBuyerForecastHistoryNotificationsSlice } from "../../../redux/actions/getBuyerForecastHistoryNotificationsSlice";


const SupplierAlertPage = () => {
    const dispatch = useDispatch();
    const [initialLoading, setInitialLoading] = useState(true);
    const [alerts, setAlerts] = useState([]);
    const userEmail = localStorage.getItem("userEmail");
    const alertDataLoading = useSelector(
        (state) => state.getAlertObsoleteSlice?.loading
    );

    useEffect(() => {
        getAlerts();

        const interval = setInterval(() => {
            getAlerts(); // silent refresh
        }, 10000);

        return () => clearInterval(interval);
    }, []);

    const getAlerts = async () => {
        try {
            const [alertResponse, consolidatedResponse, forecastHistoryNotificationResponse] = await Promise.all([
                dispatch(
                    getAlertSupplierConfirmationSlice({
                        dynamicEndpoint: `${getAlertSupplierConfirmationEndpoint}/${encodeURIComponent(userEmail)}`,
                        skipUserEmailParam: true,
                    })
                ),
                dispatch(
                    getAlertSupplierUnconfirmedConsolidatedSlice({
                        dynamicEndpoint: `${getAlertSupplierUnconfirmedConsolidatedEndpoint}/${encodeURIComponent(userEmail)}`,
                        skipUserEmailParam: true,
                    })
                ),
                dispatch(
                    getBuyerForecastHistoryNotificationsSlice({
                        dynamicEndpoint: `${getBuyerForecastHistoryNotificationsEndpoint}/${encodeURIComponent(userEmail)}`,
                        skipUserEmailParam: true,
                    })
                ),
            ]);

            let allAlerts = [];

            // API 1 - Existing Supplier Confirmation Alerts
            if (alertResponse?.meta?.requestStatus === "fulfilled") {
                const notificationAlerts = (alertResponse?.payload || []).map(
                    (item) => ({
                        id: `${item.alertId}`,
                        type: "notification",
                        title: item.title,
                        description: item.message?.items,
                        alertType: item.message?.alertType,
                        totalMaterials: item.message?.totalMaterials,
                        alertDate: item.createdAt,
                        status: item.readFlag,
                    })
                );

                allAlerts = [...allAlerts, ...notificationAlerts];
            }

            // API 2 - Unconfirmed Forecast Consolidated Alerts
            if (consolidatedResponse?.meta?.requestStatus === "fulfilled") {
                const consolidatedAlerts = (
                    consolidatedResponse?.payload || []
                ).map((item) => ({
                    id: `${item.alertId}`,
                    type: "consolidated",
                    title: "Coca-Cola Supplier Forecast Collaboration–Pending confirmations",
                    alertType: item.alertType,
                    alertDate: item.createdAt,
                    status: item.readFlag,
                }));

                allAlerts = [...allAlerts, ...consolidatedAlerts];
            }

            // API 3 - Forecast History Export Notifications
            if (forecastHistoryNotificationResponse?.meta?.requestStatus === "fulfilled") {
                const forecastHistoryAlerts = (
                    forecastHistoryNotificationResponse?.payload || []
                ).map((item) => ({
                    id: `${item.NOTIFICATION_ID}`,
                    type: "forecastHistory",
                    title: (item.TITLE || "Forecast History Notification").trim(),
                    description: (item.MESSAGE || "").trim(),
                    alertDate: item.CREATED_AT,
                    status: item.STATUS,
                    isNew: !!item.isNew,
                    fileName: item.FILE_NAME,
                    fromExtractionDate: item.FROM_EXTRACTION_DATE,
                    toExtractionDate: item.TO_EXTRACTION_DATE,
                    downloadUrl: item.downloadUrl,
                }));

                allAlerts = [...allAlerts, ...forecastHistoryAlerts];
            }

            // Sort latest first
            allAlerts.sort(
                (a, b) =>
                    new Date(b.alertDate).getTime() -
                    new Date(a.alertDate).getTime()
            );

            setAlerts(allAlerts);
        } catch (error) {
            console.error("GET ALERTS ERROR", error);
            setAlerts([]);
        } finally {
            setInitialLoading(false);
        }
    };

    return (
        <div>
            <TopSection
                labelList={[
                    { title: "Home", path: "/dashboard" },
                    { title: "Alerts" },
                ]}
                tabTitle="Alerts"
            />

            <div style={{ margin: 10 }}>
                {initialLoading ? (
                    <Loader />
                ) : alerts?.length === 0 ? (
                    <div
                        style={{
                            marginTop: 40,
                            color: "#6b7280",
                        }}
                    >
                        <h3>No alerts available</h3>
                        <p>You don’t have any notifications at the moment.</p>
                    </div>
                ) : (
                    alerts.map((alert) => (
                        <div key={alert.id} style={{ marginBottom: 10 }}>
                            <SupplierAlertCard alertData={alert} />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default SupplierAlertPage;